import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  standalone: false,
})
export class ServerErrorComponent implements OnInit {
  error: any;
  showDetails = false; // Controle para esconder/mostrar o log

  constructor(private router: Router, private location: Location) {
    const navigation = this.router.getCurrentNavigation();

    // Tenta pegar o erro do navigation state
    // Se a página for recarregada (F5), isso será null, o que é esperado
    this.error = navigation?.extras?.state?.['error'];
  }

  ngOnInit(): void {}

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  goBack() {
    this.location.historyGo(-2);
  }
}
